// extracted by mini-css-extract-plugin
export var container = "CloudinaryImage-module--container--6fc6f";
export var image = "CloudinaryImage-module--image--367b0";
export var loaded = "CloudinaryImage-module--loaded--f220d";